import { ShimmerBlock } from './Shimmer'

export function ClustersListSkeleton() {
  return (
    <div className="clu-page">
      <section className="clu-hero">
        <div className="clu-hero-left">
          <ShimmerBlock width="70%" height={44} style={{ marginBottom: 14 }} />
          <ShimmerBlock width="90%" height={16} style={{ marginBottom: 8 }} />
          <ShimmerBlock width="60%" height={16} style={{ marginBottom: 24 }} />
          <div className="clu-stats-row">
            {[0, 1, 2, 3].map(i => (
              <div className="clu-stat" key={i}>
                <ShimmerBlock width={40} height={28} style={{ marginBottom: 4 }} />
                <ShimmerBlock width={60} height={12} />
              </div>
            ))}
          </div>
          <ShimmerBlock width={180} height={44} />
        </div>
        <div className="clu-hero-map">
          <ShimmerBlock width="100%" height="100%" />
        </div>
      </section>

      <section className="clu-featured">
        <div className="clu-featured-inner">
          <ShimmerBlock width={220} height={26} />
        </div>
        <div className="clu-featured-inner">
          <div className="clu-cards-track">
            {[0, 1, 2, 3].map(i => (
              <div className="clu-card" key={i}>
                <ShimmerBlock className="clu-card-img" width="100%" height={160} radius={0} />
                <div className="clu-card-body">
                  <ShimmerBlock width="70%" height={20} style={{ marginBottom: 8 }} />
                  <ShimmerBlock width="90%" height={13} style={{ marginBottom: 14 }} />
                  <ShimmerBlock width="100%" height={30} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="clu-bottom">
        <div className="clu-cats">
          <ShimmerBlock width={220} height={24} style={{ marginBottom: 10 }} />
          <ShimmerBlock width={280} height={14} style={{ marginBottom: 20 }} />
          <div className="clu-cats-grid">
            {[0, 1, 2, 3].map(i => <ShimmerBlock key={i} width="100%" height={54} />)}
          </div>
        </div>
        <div className="clu-why">
          <ShimmerBlock width={220} height={24} style={{ marginBottom: 20 }} />
          <div className="clu-why-cards">
            {[0, 1, 2].map(i => (
              <div className="clu-why-card" key={i}>
                <ShimmerBlock width={28} height={28} />
                <div style={{ flex: 1 }}>
                  <ShimmerBlock width="50%" height={14} style={{ marginBottom: 6 }} />
                  <ShimmerBlock width="90%" height={13} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
